<div [style.height.px]="filterHeight" class="bg-white px-2 mb-4 transition-all duration-200 overflow-hidden">
  <div class="flex justify-between border-b border-gray-200 py-2">
    <div>
      <span class="text-base font-medium text-amazone-orange">Filters</span>
      <p class="text-xs text-gray-600">Search results will be immediately updated as you select or deselect filters.</p>
    </div>
    <button
      class="bg-white rounded-full hover:cursor-pointer hover:text-amazone-orange hover:scale-110 transition-all duration-300"
      (click)="closeFilters()"
      appAgentAction
      agent="error-code-filter-close"
      businessObject="errorCode"
      action="close"
    >
      <app-close-icon></app-close-icon>
    </button>
  </div>
  <div class="flex flex-wrap gap-x-4 gap-y-2 items-start mt-4 overflow-y-auto max-h-[340px] px-1 pb-4">
    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold text-gray-600">Search In</span>
      <div class="grid gap-3 mt-2">
        <label class="inline-flex items-center gap-2 text-xs text-gray-700">
          <input
            type="checkbox"
            class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            [(ngModel)]="searchQuery.searchInCode"
            (change)="onScopeChanged()"
          />
          <span>Code</span>
        </label>
        <label class="inline-flex items-center gap-2 text-xs text-gray-700">
          <input
            type="checkbox"
            class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            [(ngModel)]="searchQuery.searchInMessage"
            (change)="onScopeChanged()"
          />
          <span>Message</span>
        </label>
        <label class="inline-flex items-center gap-2 text-xs text-gray-700">
          <input
            type="checkbox"
            class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            [(ngModel)]="searchQuery.searchInDocumentationFields"
            (change)="onScopeChanged()"
          />
          <span>Documentation fields</span>
        </label>
        <label class="inline-flex items-center gap-2 text-xs text-gray-700">
          <input
            type="checkbox"
            class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            [(ngModel)]="searchQuery.searchInMachineTypes"
            (change)="onScopeChanged()"
          />
          <span>Machine types</span>
        </label>
        <label class="inline-flex items-center gap-2 text-xs text-gray-700">
          <input
            type="checkbox"
            class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            [(ngModel)]="searchQuery.searchInOtherFields"
            (change)="onScopeChanged()"
          />
          <span>Other fields</span>
        </label>
      </div>
    </div>

    <span class="h-56 w-[0.5px] bg-gray-200 mx-1"></span>

    <div class="flex flex-col">
      <span class="text-xs font-semibold text-gray-600 mb-2">Empty Fields</span>

      <div class="grid gap-x-1 gap-y-0.5 grid-cols-[max-content_1fr] items-center">
        <span class="text-xs font-light text-amazone-orange">Cause</span>
        <div></div>

        <span class="text-xs text-gray-600">Intern</span>
        <app-three-state-toggle [(ngModel)]="searchQuery.causeInternNotEmpty" (stateChange)="onScopeChanged()" />

        <span class="text-xs text-gray-600">Dealer</span>
        <app-three-state-toggle [(ngModel)]="searchQuery.causeDealerNotEmpty" (stateChange)="onScopeChanged()" />

        <span class="text-xs text-gray-600">Farmer</span>
        <app-three-state-toggle [(ngModel)]="searchQuery.causeFarmerNotEmpty" (stateChange)="onScopeChanged()" />

        <span class="text-xs font-light text-amazone-orange">Remedy</span>
        <div></div>

        <span class="text-xs text-gray-600">Intern</span>
        <app-three-state-toggle [(ngModel)]="searchQuery.remedyInternNotEmpty" (stateChange)="onScopeChanged()" />

        <span class="text-xs text-gray-600">Dealer</span>
        <app-three-state-toggle [(ngModel)]="searchQuery.remedyDealerNotEmpty" (stateChange)="onScopeChanged()" />

        <span class="text-xs text-gray-600">Farmer</span>
        <app-three-state-toggle [(ngModel)]="searchQuery.remedyFarmerNotEmpty" (stateChange)="onScopeChanged()" />
      </div>
    </div>

    <span class="h-56 w-[0.5px] bg-gray-200 mx-1"></span>

    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold text-gray-600">Categories</span>
      <div class="grid gap-3 mt-2">
        @for (category of categories; track $index) {
          <label class="inline-flex items-center gap-1 text-xs text-gray-700">
            <input
              type="checkbox"
              [checked]="category[1]"
              (change)="toggleErrorCodeCategory(category[0])"
              class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            />
            <span>{{ pascalCaseToWords(category[0]) }}</span>
          </label>
        }
      </div>
    </div>

    <span class="h-56 w-[0.5px] bg-gray-200 mx-1"></span>

    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold text-gray-600">Translationstate Terminal</span>
      <div class="grid gap-3 mt-2">
        @for (translationState of translationStatesTerminal; track $index) {
          <label class="inline-flex items-center gap-1 text-xs text-gray-700">
            <input
              type="checkbox"
              [checked]="translationState[1]"
              (change)="toggleTranslationStateTerminal(translationState[0])"
              class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            />
            <span>{{ pascalCaseToWords(translationState[0]) }}</span>
          </label>
        }
      </div>
    </div>

    <span class="h-56 w-[0.5px] bg-gray-200 mx-1"></span>

    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold text-gray-600">Translationstate Documentation</span>
      <div class="grid gap-3 mt-2">
        @for (translationState of translationStatesDocumentation; track $index) {
          <label class="inline-flex items-center gap-1 text-xs text-gray-700">
            <input
              type="checkbox"
              [checked]="translationState[1]"
              (change)="toggleTranslationStateDocumentation(translationState[0])"
              class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            />
            <span>{{ pascalCaseToWords(translationState[0]) }}</span>
          </label>
        }
      </div>
    </div>
    <span class="h-56 w-[0.5px] bg-gray-200 mx-1"></span>
    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold text-gray-600">Project</span>
      <div class="grid gap-3 mt-2">
        <button
          [id]="'dropdownRadioButtonProject' + uniqueId"
          [attr.data-dropdown-toggle]="'dropdownRadioProject' + uniqueId"
          class="inline-flex items-center justify-center text-amazone-gray-700 bg-white box-border border border-transparent hover:bg-brand-strong focus:ring-4 focus:ring-amazone-orange shadow-xs leading-5 rounded-base text-xs px-4 py-2.5 focus:outline-none"
          type="button"
          appAgentAction
          agent="error-code-filter-project-dropdown-toggle"
          businessObject="errorCode"
          action="toggle"
        >
          {{ selectedProjectName }}
          <svg
            class="w-4 h-4 ms-1.5 -me-0.5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m19 9-7 7-7-7"
            />
          </svg>
        </button>

        <div
          [id]="'dropdownRadioProject' + uniqueId"
          class="z-10 hidden bg-white border border-default-medium rounded-base shadow-lg w-44"
        >
          <ul class="p-2 text-sm text-body font-medium" [aria-labelledby]="'dropdownRadioButtonProject' + uniqueId">
            @for (project of projects; track $index) {
              <li>
                <label class="select-none ms-2 text-xs font-medium text-heading">
                  <div class="inline-flex items-center w-full p-2">
                    <input
                      type="radio"
                      value=""
                      name="default-radio"
                      class="w-4 h-4 text-amazone-orange border-gray-300 bg-neutral-secondary-strong rounded-full checked:amazone-orange focus:ring-2 focus:outline-none focus:ring-amazone-orange border border-default appearance-none"
                      (click)="selectProject(project.id, project.title)"
                      [checked]="project.selected"
                      appAgentAction
                      [agent]="'error-code-filter-project-' + project.id"
                      businessObject="errorCode"
                      action="filter"
                    />
                    <span>&nbsp;{{ project.title }}</span>
                  </div>
                </label>
              </li>
            }
          </ul>
        </div>
      </div>

      <span class="text-xs font-semibold text-gray-600 mt-4">NwNumbers</span>
      <div class="grid gap-3 mt-2">
        @for (nwNumber of nwNumbers; track $index) {
          <label class="inline-flex items-center gap-1 text-xs text-gray-700">
            <input
              type="checkbox"
              [checked]="nwNumber[1]"
              (change)="toggleNwNumber(nwNumber[0])"
              class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            />
            <span>{{ nwNumber[0].number }}</span>
          </label>
        }
      </div>
    </div>

    <span class="h-56 w-[0.5px] bg-gray-200 mx-1"></span>

    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold text-gray-600">Reviews</span>

      <div class="grid gap-x-1 gap-y-0.5 grid-cols-[max-content_1fr] items-center">
        <span class="text-xs text-gray-600">Reviewed by AS</span>
        <app-three-state-toggle
          [(ngModel)]="searchQuery.isReviewedByAfterSales"
          (stateChange)="onScopeChanged()"
          textTrue="Yes"
          textFalse="No"
        />

        <span class="text-xs text-gray-600">In review by AS</span>
        <app-three-state-toggle
          [(ngModel)]="searchQuery.hasActiveAfterSalesReview"
          (stateChange)="onScopeChanged()"
          textTrue="Yes"
          textFalse="No"
        />

        <span class="text-xs text-gray-600">Reviewed by TO</span>
        <app-three-state-toggle
          [(ngModel)]="searchQuery.isReviewedByTechnicalOrganisation"
          (stateChange)="onScopeChanged()"
          textTrue="Yes"
          textFalse="No"
        />

        <span class="text-xs text-gray-600">In review by TO</span>
        <app-three-state-toggle
          [(ngModel)]="searchQuery.hasActiveTechnicalOrganisationReview"
          (stateChange)="onScopeChanged()"
          textTrue="Yes"
          textFalse="No"
        />

        <span class="text-xs text-gray-600">Doc. reviewed by TR</span>
        <app-three-state-toggle
          [(ngModel)]="searchQuery.mainLanguageDocumentationFieldsReviewed"
          (stateChange)="onScopeChanged()"
          textTrue="Yes"
          textFalse="No"
        />
      </div>
    </div>

    <span class="h-56 w-[0.5px] bg-gray-200 mx-1"></span>

    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold text-gray-600">Other</span>
      <div class="grid gap-3 mt-2">
        <label class="inline-flex items-center gap-2 text-xs text-gray-700">
          <input
            type="checkbox"
            class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            [(ngModel)]="searchQuery.needsReview"
            (change)="onScopeChanged()"
          />
          <span>Needs Review</span>
        </label>
        <label class="inline-flex items-center gap-2 text-xs text-gray-700">
          <input
            type="checkbox"
            class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            [(ngModel)]="searchQuery.mainLanguageDocumentationFieldsExportedForReview"
            (change)="onScopeChanged()"
          />
          <span>Main lang. documentation fields exported for review</span>
        </label>
        <label class="inline-flex items-center gap-2 text-xs text-gray-700">
          <input
            type="checkbox"
            class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange"
            [checked]="searchQuery.changesBy != undefined"
            (change)="changesByMe()"
          />
          <span>Changes by me</span>
        </label>
      </div>
    </div>

    <button
      type="button"
      class="ml-auto text-white bg-amazone-gray hover:bg-gray-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-xs px-3 py-1.5 cursor-pointer self-end"
      (click)="resetFilters()"
      appAgentAction
      agent="error-code-filter-reset"
      businessObject="errorCode"
      action="reset"
    >
      Reset
    </button>
  </div>
</div>
